import {NgModule} from "@angular/core";
import {ArkivTrevisningKomponentAvhengigheter} from "./komponenter/arkiv-trevisning/arkiv-trevisning";
import {ArkivVelgNodeKomponentAvhengigheter} from "web-ng2/moduler/arkiv/komponenter/arkiv-velg-node/arkiv-velg-node";
import {ArkivmappeMenyKomponentAvhengigheter} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-meny/arkivmappe-meny";
import {ArkivFlyttNodeDialogKomponentAvhengigheter} from "web-ng2/moduler/arkiv/modale/arkiv-flytt-node-dialog/arkiv-flytt-node-dialog";
import {ArkivImporterZipDialogKomponentAvhengigheter} from "web-ng2/moduler/arkiv/modale/arkiv-importer-zip-dialog/arkiv-importer-zip-dialog";
import {ArkivmappeOpprettRedigerDialogKomponentAvhengigheter} from "web-ng2/moduler/arkiv/modale/arkivmappe-opprett-rediger-dialog/arkivmappe-opprett-rediger-dialog";
import {ArkivmappeDetaljerKomponentAvhengigheter} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-detaljer/arkivmappe-detaljer";

@NgModule({
    providers: [
        ArkivTrevisningKomponentAvhengigheter,
        ArkivVelgNodeKomponentAvhengigheter,
        ArkivmappeMenyKomponentAvhengigheter,
        ArkivFlyttNodeDialogKomponentAvhengigheter,
        ArkivImporterZipDialogKomponentAvhengigheter,
        ArkivmappeOpprettRedigerDialogKomponentAvhengigheter,
        ArkivmappeDetaljerKomponentAvhengigheter
    ]
})
export class ArkivModul{

}
